import React from 'react'
import '../css/Contact.css';
import SocialMediaIcons from './SocialMediaIcons';

export default function Contact() {
  return (
    <>
        <h4>Contact: <br />
            (336)-509-2070 <br />
            skyler.greensboro@gmail.com <br /></h4>
            <div>
                <SocialMediaIcons />
            </div>

        <h4>** I own all the rights to my music. Any monetary redistribution of intellectual property found on this page without credit and compensation to the original artist will receive legal action from the U.S. Copyright Office and their affiliates.**</h4>
    </>
  )
}
